<template>
  <div>
    <v-fade-transition>
      <v-banner
        v-show="showCallBanner && !isMinimized"
        style="
          position: fixed;
          z-index: 203;
          min-width: 400px;
          bottom: 25px;
          left: 50%;
          transform: translateX(-50%);
        "
        class="rounded-xl blue-grey"
        elevation="8"
        dark
        tile
      >
        <v-row style="width: 100; padding: 20px" justify="space-between">
          <v-col cols="12">
            <v-row justify="space-between">
              <v-col cols="5" sm="5">
                <p class="mb-0">{{ callStatusText }}</p>
                <p class="mb-0" v-if="DisplayNameObj.number">{{ DisplayNameObj.number }}</p>
                <p class="mb-0" v-if="DisplayNameObj.var2">{{ DisplayNameObj.var2 }}</p>
                <p class="mb-0">{{ DisplayNameObj.var1 }}</p>
                <p v-if="!hasIncomingCall" class="subtitle-2 mb-3">
                  {{ phoneNumber }}
                </p>
                <counter v-if="hasInProgressCall" :status="counterStatus"></counter>
              </v-col>
              <v-col cols="7" sm="5" class="d-flex justify-center align-center">
                <v-row class="h-100" justify="space-around">
                  <v-col cols="12" class="py-0 d-flex justify-end">
                    <v-btn class="ml-auto" @click="isMinimized = true" fab dark x-small plain>
                      <v-icon dark> mdi-minus </v-icon>
                    </v-btn>
                  </v-col>
                  <template v-if="hasInProgressCall">
                    <v-col cols="auto" class="pa-0 py-5">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :color="`${isMuted ? 'white' : 'success'} mx-2`"
                            small
                            @click="onToggleMute"
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            fab
                          >
                            <v-icon :color="`${isMuted ? 'black' : 'white'}`">
                              mdi-microphone-off
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Silenciar</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="auto" class="pa-0 py-5">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            :color="`${showNumPad ? 'white' : 'success'} mx-2`"
                            @click="showNumPad = !showNumPad"
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            fab
                          >
                            <v-icon :color="`${showNumPad ? 'black' : 'white'}`">
                              mdi-dialpad
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Teclado</span>
                      </v-tooltip>
                    </v-col>
                    <!-- Hold btn -->
                    <v-col cols="auto" class="pa-0 py-5">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="success mx-2" small v-bind="attrs" v-on="on" @click="onToggleHold" rounded fab>
                            <v-icon v-if="isActiveHold"> mdi-play </v-icon>

                            <v-icon v-else> mdi-pause </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ isActiveHold ? "Reanudar" : "Espera" }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="6" class="pa-0 py-5 d-flex justify-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="success mx-2"
                            small
                            @click="onTransferCall"
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            fab
                          >
                            <v-icon> mdi-call-split </v-icon>
                          </v-btn>
                        </template>
                        <span>Transferir</span>
                      </v-tooltip>
                    </v-col>
                  </template>

                  <v-col v-if="hasIncomingCall" cols="6" class="pa-0 d-flex justify-center align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="onAnswerCall" v-bind="attrs" v-on="on" color="success mx-2" small rounded fab>
                          <v-icon v-if="isVideoCall">mdi-video</v-icon>
                          <v-icon v-else>mdi-phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Contestar</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="6" class="pa-0 py-5 d-flex justify-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="onHangup" v-bind="attrs" v-on="on" color="red darken-2 mx-2" small rounded fab>
                          <v-icon>mdi-phone-hangup</v-icon>
                        </v-btn>
                      </template>
                      <span>Colgar</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" :class="isVideoCall && !hasIncomingCall ? 'd-flex' : 'd-none'" style="gap: 30px">
            <div id="divVideoRemote">
              <video class="video" width="100%" height="100%" id="video_remote" autoplay="autoplay"></video>
            </div>

            <div id="divVideoLocalWrapper" style="">
              <iframe class="previewvideo" style="border: 0px solid #009; z-index: 1000"> </iframe>
              <div id="divVideoLocal" class="previewvideo">
                <video
                  class="video"
                  width="100%"
                  height="100%"
                  id="video_local"
                  autoplay="autoplay"
                  muted="true"
                ></video>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-banner>
    </v-fade-transition>
    <v-fade-transition>
      <minimized-dialer-btn
        :hasInProgressCall="hasInProgressCall"
        :counterStatus="counterStatus"
        :show="showCallBanner && isMinimized"
        @click="isMinimized = false"
      ></minimized-dialer-btn>
    </v-fade-transition>
    <VueNumericKeypad
      defaultStyle="wrap"
      :value.sync="DTMF"
      :show.sync="showNumPad"
      :options="dtmfOptions"
      :fixDeleteKey="false"
    />
  </div>
</template>

<script>
import VueNumericKeypad from "vue-numeric-keypad";
import Counter from "./Counter.vue";
import MinimizedDialerBtn from "./MinimizedDialerBtn.vue";

export default {
  components: { Counter, VueNumericKeypad, MinimizedDialerBtn },
  props: {
    showCallBanner: {
      type: Boolean,
    },
    callStatusText: {
      type: String,
    },
    displayName: {
      type: String,
    },
    phoneNumber: {
      type: String,
    },
    hasIncomingCall: {
      type: Boolean,
    },
    isActiveHold: {
      type: Boolean,
    },
    hasInProgressCall: {
      type: Boolean,
    },
    counterStatus: {
      type: String,
      default: "play",
    },
    isMuted: {
      type: Boolean,
    },
    isVideoCall: {
      type: Boolean,
    },
  },
  data: () => ({
    showNumPad: false,
    isMinimized: false,
    DTMF: "",
    dtmfOptions: {
      keyRandomize: false,
      keyArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, "*", 0, "#"],
    },
  }),

  computed: {
    DisplayNameObj() {
      if (this.displayName?.includes("*")) {
        const [var1, var2, number] = this.displayName.split("*");
        return { var1, var2, number };
      }

      return { var2: this.displayName || "" };
    },
  },

  watch: {
    DTMF() {
      this.onDTMF();
    },
    showCallBanner(val) {
      if (!val) this.showNumPad = false;
    },
  },

  methods: {
    onToggleMute() {
      this.$emit("call:toggleMute");
    },
    onToggleHold() {
      this.$emit("call:toggleHold");
    },
    onTransferCall() {
      this.$emit("call:transfer");
    },
    onAnswerCall() {
      this.$emit("call:answer");
    },
    onHangup() {
      this.$emit("call:hangup");
    },
    onDTMF() {
      this.$emit("call:dtmf", this.DTMF);
    },
  },
};
</script>

<style>
.numeric-keypad__button {
  background-color: #eff0f8;
  border: none !important;
}

.numeric-keypad,
.numeric-keypad__button-wrap {
  background-color: #607d8b !important;
}
.numeric-keypad {
  position: fixed;
  width: 90%;
  max-width: 400px;
  transform: translateX(-50%);
  border-radius: 10px !important;
  z-index: 203 !important;
  left: 50% !important;
  bottom: 240px !important;
}

@media (min-width: 1124px) {
  .numeric-keypad {
    left: 100% !important;
    max-width: 300px;
    bottom: 25px !important;
    transform: translateX(-100%);
  }
}
#dialer-minimized p {
  font-size: 12px !important;
}

#divVideoRemote {
  position: relative;
  box-shadow: rgb(61, 61, 61) 0px 0px 10px;
  border-radius: 20px;
  margin-bottom: 25px;
  height: 250px;
  width: 100%;
  z-index: auto;
  opacity: 1;
}

#divVideoRemote video {
  opacity: 0;
  background-color: #000000;
  -webkit-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-duration: 2s;
  transition-duration: 2s;
}
#divVideoLocalWrapper {
  position: relative;
  margin-left: 0px;
  box-shadow: rgb(61, 61, 61) 0px 0px 10px;
  z-index: 1000;
  height: 250px;
  width: 100%;
}

#divVideoLocalWrapper,
#divVideoRemote,
#divVideoRemote > video,
.previewvideo,
.previewvideo > video {
  border-radius: 20px;
}

#video_local {
  opacity: 0;
  background-color: #000000;
  -webkit-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-duration: 2s;
  transition-duration: 2s;
}

#divVideoLocal {
  border: 0px solid #009;
  z-index: 1000;
}

.previewvideo {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
